<template>
    <q-card class="card">
        <q-expansion-item default-opened :hoverable="false" class="expansion-item">
            <template #header>
                <WidgetHeader :title="label" :icon="icon" />
            </template>
            <slot />
        </q-expansion-item>
    </q-card>
</template>

<script setup lang="ts">
import WidgetHeader from "@/shared/components/widgets/widget-header.vue";

interface WidgetProps {
    icon: string;
    label: string;
}
defineProps<WidgetProps>();
</script>

<style lang="scss" scoped>
.card {
    background-color: transparent;
}
.expansion-item {
    &:deep(.q-item) {
        border-radius: $default-border-radius;
        &:first-child {
            padding-left: 0;
            padding-right: 0;
        }
    }
    &:deep(.q-hoverable:hover > .q-focus-helper) {
        background: $white !important;
    }

    &:deep(.q-item__label) {
        font-size: 16px;
        font-weight: $semi-bold;
    }

    &:deep(.q-item__section--side > .q-icon) {
        font-size: 20px;
    }
}
</style>
